<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <h2 class="brand-text text-primary ml-1">
          {{ process }}
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img
            style="border-radius: 10px"
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            مرحباً بك 👋
          </b-card-title>
          <b-card-text class="mb-2">
            قم بانشاء حساب جديد او تسجيل الدخول.
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- email -->
              <b-form-group label="الاسم" label-for="login-email1">
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
                >
                  <b-form-input
                    id="login-email1"
                    v-model="name"
                    :state="errors.length > 0 ? false : null"
                    name="login-email1"
                    placeholder="اكتب هنا..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- email -->
              <b-form-group label="الجوال" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Phone"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="اكتب هنا..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">كلمة المرور</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                انشاء الحساب الآن
              </b-button>
            </b-form>
          </validation-observer>
          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">
              لديك حساب؟
              <strong>
                <button
                  class="text-danger btn btn-sm btn-secondary"
                  v-b-modal.modal-1
                >
                  تسجيل الدخول
                </button>
              </strong>
            </div>
          </div>
          <br />
          احدى خدمات شركة
          <a href="https://brmja.com" target="_blank" class="text-success"
            >برمجة دوت كوم</a
          >
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
    <b-modal id="modal-1" title="تسجيل الدخول" ok-only hide-footer>
      <b-card-text>
        <div class="form-group">
          <label for="">الجوال</label>
          <input type="text" class="form-control" v-model="loginPhone" />
        </div>
        <div class="form-group">
          <label for="">كلمة المرور</label>
          <input type="password" class="form-control" v-model="loginPassword" />
        </div>
        <div class="col-12 text-center">
          <button class="btn btn-primary" @click="login()">تسجيل الدخول</button>
        </div>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BModal,
  VBModal,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      process: process.env.VUE_APP_TITLE,
      status: "",
      password: "",
      userEmail: "",
      name: "",
      sideImg: require("@/assets/images/pages/login-v2.svg"),
      required,
      email,
      loginPhone: "",
      loginPassword: "",
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  created(){
    var g = this;
    if(window.location.href.includes('auto-register')){
      $.post(api + "/user/auth/register", {
            phone: window.location.href.split("phone=")[1].split("&")[0],
            password: window.location.href.split("password=")[1].split("&")[0],
            name: decodeURI(window.location.href.split("name=")[1].split("&")[0]),
            code: window.location.href.split("code=")[1].split("&")[0],
          })
            .then(function (e) {
              if (e.status != 100) {
                g.$toast({
                  component: ToastificationContent,
                  props: {
                    title: e.response,
                    icon: "TimesIcon",
                    variant: "danger",
                  },
                });
              } else {
                localStorage.setItem("user", JSON.stringify(e.response));
                window.location = "/";
              }
            })
            .catch(function () {
              g.$toast({
                component: ToastificationContent,
                props: {
                  title: "حدث خطأ",
                  icon: "TimesIcon",
                  variant: "danger",
                },
              });
            });
    }
  },
  methods: {
    login() {
      var g = this;
      $.post(api + "/user/auth/login", {
        phone: this.loginPhone,
        password: this.loginPassword,
      })
        .then(function (e) {
          if (e.status != 100) {
            g.$toast({
              component: ToastificationContent,
              props: {
                title: e.response,
                icon: "TimesIcon",
                variant: "danger",
              },
            });
          } else {
            localStorage.setItem("user", JSON.stringify(e.response));
            window.location = "/";
          }
        })
        .catch(function () {
          g.$toast({
            component: ToastificationContent,
            props: {
              title: "حدث خطأ",
              icon: "TimesIcon",
              variant: "danger",
            },
          });
        });
    },
    validationForm() {
      var g = this;
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          $.post(api + "/user/auth/register", {
            phone: this.userEmail,
            password: this.password,
            name: this.name,
            code: window.location.href.includes('code') ? window.location.href.split("code=")[1].split("&")[0] : ''
          })
            .then(function (e) {
              if (e.status != 100) {
                g.$toast({
                  component: ToastificationContent,
                  props: {
                    title: e.response,
                    icon: "TimesIcon",
                    variant: "danger",
                  },
                });
              } else {
                localStorage.setItem("user", JSON.stringify(e.response));
                window.location = "/";
              }
            })
            .catch(function () {
              g.$toast({
                component: ToastificationContent,
                props: {
                  title: "حدث خطأ",
                  icon: "TimesIcon",
                  variant: "danger",
                },
              });
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
